import React, { useMemo } from "react";
import { Navigate } from "react-router";
import { shallowEqual, useSelector } from "react-redux";
import { canAccessDebtCollectionFlow } from "./debtCollectionRoles";
import { DebtCollectionUIProvider } from "./DebtCollectionUIContext";
import { DebtCollectionCard } from "./DebtCollectionCard";

/**
 * Settings route page for debt collection; redirects users without access.
 * @returns {JSX.Element} Debt collection UI or redirect to settings home.
 */
export function DebtCollectionPage() {
  const roles = useSelector((state) => state.auth.user?.roles, shallowEqual);

  const isDebtCollectionAllowed = useMemo(
    () => canAccessDebtCollectionFlow(roles),
    [roles],
  );

  if (!isDebtCollectionAllowed) {
    return <Navigate to="/setting-page" replace />;
  }

  return (
    <DebtCollectionUIProvider>
      <DebtCollectionCard />
    </DebtCollectionUIProvider>
  );
}
